<form
    #nameForm="ngForm"
    id="nameForm"
    (ngSubmit)="submitForm(continueButtonTranslationKey === 'MACHINE_LEARNING.SELECT_DATASET.ANNOTATE_BUTTON_TEXT')"
    autocomplete="off"
    data-uit="selected-files-section"
    class="selected-files-form"
    [ngClass]="isMEDProjectEnabled ? 'MED-create-and-start-dialog-app-run' : 'arivis-Cloud-create-and-start-dialog'"
>
    <div class="modal-header d-flex flex-column">
        <div d-flex flex-column>
            <h2 class="modal-title mb-2">{{ modalTitleTranslationKey | translate }}</h2>
            <button
                type="button"
                class="btn ca-btn-icon ca-btn-icon-big modal-button-close"
                (click)="dismiss()"
                data-uit="close-modal"
                [disabled]="!selectedFiles"
                [title]="'GENERAL.CLOSE' | translate"
            >
                <ca-icon name="cross" size="l"></ca-icon>
            </button>
        </div>
        <div class="d-flex flex-sm-column flex-lg-row info flex-wrap w-100" [ngClass]="shouldNameFormBeShown ? 'mb-0' : 'mb-2'">
            <div class="d-flex align-items-center flex-lg-row flex-column title-subtext" *ngIf="isCziConversionActivatedForUploadedFiles">
                <p class="mb-0">
                    {{
                        isMEDProjectEnabled
                            ? modalTitleTranslationKey === 'MACHINE_LEARNING.SELECT_DATASET.TITLE_IMAGES'
                                ? ('CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.MED.SELECT_FILES_TO_ANNOTATE' | translate)
                                : ('CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.MED.SELECT_FILES_TO_RUN' | translate)
                            : ('CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.HINT.FILES_WILL_BE_CONVERTED' | translate)
                    }}
                    <strong *ngIf="isMEDProjectEnabled && parentFolderName">{{ parentFolderName }}.</strong>
                </p>
                <ng-container *ngIf="!isMEDProjectEnabled">
                    <div class="d-flex align-items-center">
                        <b *ngIf="isFileExplorerShown">{{ 'CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.HINT.ORIGINALS_NO_LONGER_ACCESSIBLE' | translate }}</b>
                        <button type="button" class="btn btn-link-underline btn-sm border-0 p-0 ps-1" (click)="openSupportedFormatsDialog()">
                            {{ 'CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.HINT.SUPPORTED_FORMATS' | translate }}
                        </button>
                    </div>
                </ng-container>
            </div>
            <div class="d-flex w-100 mt-3" [ngClass]="isFileExplorerShown ? 'flex-lg-row flex-column align-items-center' : 'flex-column'">
                <div
                    class="d-flex flex-column-reverse form-group input-form-name"
                    [ngClass]="isFileExplorerShown ? 'mb-3' : 'w-100'"
                    *ngIf="shouldNameFormBeShown"
                >
                    <input
                        type="text"
                        class="form-control"
                        data-uit="name-input"
                        [(ngModel)]="name"
                        name="name"
                        [placeholder]="namePlaceholderTranslationKey | translate"
                        required
                        [ngClass]="{ 'has-error': shouldCheckValidityOfName && nameForm.dirty && nameForm.form.invalid }"
                        (blur)="validate()"
                        caAutoFocus
                    />
                    <div class="d-flex justify-content-between align-items-baseline">
                        <label class="w-50">{{ nameLabelTranslationKey | translate }}<span class="ms-1 red">*</span></label>
                        <small *ngIf="nameForm.dirty && nameForm.form.invalid" class="invalid-feedback w-50 text-end">
                            {{ 'GENERAL.REQUIRED_FIELD' | translate }}
                        </small>
                    </div>
                </div>
                <div class="dataset-name text-truncate" *ngIf="currentPreselectedDataset">
                    <span class="text-pale">{{ 'CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.DATASET_NAME' | translate }}:</span>&nbsp;
                    <span ngbTooltip="{{ currentPreselectedDataset.name }}" container="body" placement="top">{{ currentPreselectedDataset.name }}</span>
                </div>
                <div
                    data-uit="uploaded-files-msg-run-name"
                    class="d-flex text-nowrap file-save-location font-s ps-1"
                    [ngClass]="isFileExplorerShown && shouldNameFormBeShown ? 'align-self-center uploaded-files-path-breadcrumb' : 'ms-0 mb-2 mt-2'"
                >
                    <span class="text-pale" [ngClass]="isFileExplorerShown && shouldNameFormBeShown ? 'ps-lg-3 ps-0' : 'ps-0'">{{
                        'CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.UPLOADED_FILES_MESSAGE' | translate
                    }}</span
                    >&nbsp;
                    <ng-container *ngIf="parentFolderName; else datasetBreadcrumbs">
                        <div
                            class="text-truncate"
                            ngbTooltip="
                                {{
                                isMEDProjectEnabled ? ('MY_WORKSPACE.MY_DATA.BROWSER_TITLE' | translate) : ('MY_WORKSPACE.MY_FILES.BROWSER_TITLE' | translate)
                            }}
                                {{ parentFolderName && !isMEDProjectEnabled ? '>' : '' }}
                                {{ isMEDProjectEnabled ? '' : parentFolderName }} {{ name ? '>' : '' }} {{ name }}
                                        "
                            container="body"
                            placement="top"
                        >
                            {{ isMEDProjectEnabled ? ('MY_WORKSPACE.MY_DATA.BROWSER_TITLE' | translate) : ('MY_WORKSPACE.MY_FILES.BROWSER_TITLE' | translate) }}
                            {{ parentFolderName && !isMEDProjectEnabled ? '>' : '' }}
                            {{ isMEDProjectEnabled ? '' : parentFolderName }} {{ name ? '>' : '' }} {{ name }}
                        </div>
                    </ng-container>
                    <ng-template #datasetBreadcrumbs>
                        {{ 'MACHINE_LEARNING.ANNOTATE.SECTION_TITLE' | translate }}&nbsp;>&nbsp;
                        <div
                            class="text-truncate"
                            [ngbTooltip]="currentPreselectedDataset ? currentPreselectedDataset.name : name"
                            container="body"
                            placement="top"
                        >
                            {{ currentPreselectedDataset ? currentPreselectedDataset.name : name }}&nbsp;>&nbsp;
                        </div>
                        <span *ngIf="datasetExplorerFolderHandlerType === datasetFileTypeOptionEnum.FILES">
                            <span class="text-truncate" [ngbTooltip]="'MACHINE_LEARNING.ANNOTATE.IMAGES_TITLE' | translate" container="body" placement="top">
                                {{ 'MACHINE_LEARNING.ANNOTATE.IMAGES_TITLE' | translate }}
                            </span>
                        </span>
                        <span *ngIf="datasetExplorerFolderHandlerType === datasetFileTypeOptionEnum.ANNOTATIONS">
                            <span
                                class="text-truncate"
                                [ngbTooltip]="'MACHINE_LEARNING.ANNOTATE.ANNOTATIONS_TITLE' | translate"
                                container="body"
                                placement="top"
                            >
                                {{ 'MACHINE_LEARNING.ANNOTATE.ANNOTATIONS_TITLE' | translate }}
                            </span>
                        </span>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
    <div
        class="modal-body mb-3 create-and-start-dialog-modal-body create-and-start-dialog-upper-modal-content"
        [ngClass]="{ 'with-opened-selection-part': isFileExplorerShown, 'right-side-translate-y-0': shouldNameFormBeShown }"
        data-uit="create-and-start-dialog-modal-body"
    >
        <div class="row mb-3 px-2 create-and-start-dialog-scollable-table-section" *ngIf="isFileExplorerShown; else selectedFilesSection">
            <div class="col-md-6 split-left file-explorer-container">
                <ca-file-explorer
                    [currentView]="'dataset'"
                    [foldersToHideIds]="[currentPreselectedDataset?.datasetId]"
                    [truncateFileNameAtWidthOf]="200"
                    [foldersToHideIds]="currentPreselectedDataset?.datasetId"
                    [shouldBackButtonBeShown]="false"
                    [isFilesStatusShown]="false"
                    [isUploadModal]="true"
                    (onFileSelected)="onFilesSelected([$event])"
                    (onMultipleFilesSelected)="onFilesSelected($event)"
                    class="modal-view"
                ></ca-file-explorer>
            </div>
            <div class="col-md-6 split-right"><ng-container *ngTemplateOutlet="selectedFilesSection"></ng-container></div>
        </div>
        <ng-template #selectedFilesSection>
            <div class="row" *ngIf="datasetExplorerFolderHandlerType === datasetFileTypeOptionEnum.ANNOTATIONS && !isMEDProjectEnabled"></div>
            <div class="row selected-files-row">
                <div class="col">
                    <ca-selected-files
                        data-uit="selected-files"
                        [operationId]="operationId"
                        [columns]="columns"
                        [isSegmentation]="isSegmentation"
                        [isMedCZIConversionDisabled]="isMEDCZIDisabled"
                        [selectedModel]="selectedModel"
                        [isResetButtonShown]="!isMEDProjectEnabled"
                        [isFileExplorerShown]="isFileExplorerShown"
                        [isSelectedFilesShown]="isSelectedFilesShown"
                        [isUploadOfFilesEnabled]="isUploadOfFilesEnabled"
                        [selectedFiles]="selectedFiles"
                        [uploaderKey]="isUploadOfFilesEnabled ? 'selectedFiles_' + operationId : ''"
                        [supportedFileTypes]="supportedFileTypes"
                        [targetFolderToBeCreated]="targetFolderToBeCreated"
                        [datasetId]="currentPreselectedDataset?.datasetId"
                        [datasetFileType]="datasetExplorerFolderHandlerType"
                        (changeSearchAndSortOptions)="onChangeSearchAndSortOptions($event)"
                        (selectedFilesUpdated)="onSelectedFilesUpdated($event)"
                        (targetFolderCreated)="onTargetFolderCreated($event)"
                        (isCziConversionInProgressChange)="handleCziConversionInProgressChange($event)"
                        (isValidationInProgressChange)="handleValidationInProgressChange($event)"
                        (removeItems)="removeFiles.emit($event)"
                    ></ca-selected-files>
                </div>
            </div>
        </ng-template>
    </div>
    <div class="modal-footer modal-buttons direction-column">
        <button
            type="button"
            *ngIf="!isFileExplorerShown"
            class="btn btn-secondary w-100 text-transform-unset m-0"
            data-uit="open-select-section-btn"
            (click)="openSelectionSection()"
        >
            {{
                isMEDProjectEnabled
                    ? ('CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.ADD_FROM_DATA' | translate)
                    : ('CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.ADD_FROM_ARIVIS_CLOUD_BUTTON' | translate)
            }}
        </button>
        <button
            *ngIf="!isSelectedFilesShown"
            type="button"
            class="btn btn-secondary w-100 my-0"
            [ngClass]="!isFileExplorerShown ? 'mx-1' : 'ms-0 me-1'"
            data-uit="file-upload-btn"
            (click)="uploadSection.click()"
        >
            <ng-container *ngIf="datasetExplorerFolderHandlerType === datasetFileTypeOptionEnum.ANNOTATIONS; else imagesButton">
                {{ 'CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.UPLOAD_ANNOTATIONS_BUTTON' | translate }}
            </ng-container>
            <ng-template #imagesButton>
                {{ 'CREATE_AND_START_PROJECT_SEGMENTATION_DIALOG.UPLOAD_IMAGES_BUTTON' | translate }}
            </ng-template>
            <input #uploadSection type="file" data-uit="file-upload-input" ng2FileSelect [uploader]="uploader" [multiple]="true" hidden />
        </button>
        <button
            type="button"
            class="btn btn-primary m-0"
            [ngClass]="isMEDProjectEnabled ? 'w-50 ms-auto' : 'w-100'"
            [disabled]="isProceedButtonDisabled()"
            (click)="handleProceedClick()"
            data-uit="start-btn"
            *ngIf="isRunButtonVisible"
        >
            {{ continueButtonTranslationKey | translate }}
        </button>
    </div>
</form>
